import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, FileText, MoreVertical, Trash2, Edit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { mockDrafts } from '@/lib/mockData';
import { formatDate } from '@/lib/utils';

export function AdminDraftList() {
  return (
    <AdminLayout>
      <div className="p-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-white">Draft Events</h1>
            <p className="text-muted-foreground mt-1">{mockDrafts.length} drafts saved</p>
          </div>
          <Link to="/admin/events/new/basics">
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
              <Plus className="w-4 h-4 mr-2" />
              New Event
            </Button>
          </Link>
        </div>

        {mockDrafts.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="w-20 h-20 bg-card rounded-xl border border-border flex items-center justify-center mb-4">
              <FileText className="w-10 h-10 text-muted-foreground" />
            </div>
            <h2 className="text-xl font-semibold text-white mb-2">No Drafts</h2>
            <p className="text-muted-foreground">You don&apos;t have any draft events</p>
          </div>
        ) : (
          <div className="space-y-4">
            {mockDrafts.map(draft => (
              <Card key={draft.id} className="bg-card border-border p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-secondary rounded-lg flex items-center justify-center">
                      <FileText className="w-6 h-6 text-muted-foreground" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-white">{draft.title}</h3>
                      <p className="text-sm text-muted-foreground">
                        Last modified: {formatDate(draft.lastModified)} • Step: {draft.step}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Link to="/admin/events/new/basics">
                      <Button variant="outline" size="sm" className="border-border">
                        <Edit className="w-4 h-4 mr-2" />
                        Continue
                      </Button>
                    </Link>
                    <Link to={`/admin/events/${draft.id}/delete`}>
                      <Button variant="outline" size="sm" className="border-destructive text-destructive hover:bg-destructive hover:text-white">
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </Link>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}

export default AdminDraftList;
